export enum PropertyFlagsTypes {
  FIVE_ACRES_OR_GREATER = 'five-acres-or-greater',
  TEN_ACRES_OR_GREATER = 'ten-acres-or-greater',
  MOBILE_HOME = 'mobile-home',
}

export const propertyFlagsCopy = {
  [PropertyFlagsTypes.FIVE_ACRES_OR_GREATER]:
    'Our automated valuation engine detected that your property is 5 acres or more. Is your property equal to or greater than 5 acres?',
  [PropertyFlagsTypes.TEN_ACRES_OR_GREATER]:
    'Our automated valuation engine detected that your property is 10 acres or more. Is your property equal to or greater than 10 acres?',
  [PropertyFlagsTypes.MOBILE_HOME]:
    'Our automated valuation engine detected  that your property is a mobile/manufactured home. Is your property a mobile/manufactured home?',
}
